module.exports = __webpack_public_path__ + "static/media/wave-build-a-welding-mask.png";